import React, { Component } from 'react';
import Select from 'react-select';

import { extendUrlParams } from '../helpers';
import '../styles/select.scss';

class LanguageSelect extends Component {
  onChange = ({ value }) => {
    if (this.props.value === value) {
      return;
    }

    const urlParams = extendUrlParams({ locale: value });

    window.location.replace(
      `${window.location.origin}${window.location.pathname}?${urlParams}`,
    );
  };

  render() {
    const { ...rest } = this.props;
    const options = rest.options;
    const selected = options.find(v => v.value === rest.value);

    return (
      <Select
        className="react-select-container"
        classNamePrefix="react-select"
        options={options}
        onChange={this.onChange}
        isSearchable={false}
        value={[selected]}
        selectedValue={selected}
        placeholder=""
      />
    );
  }
}

export default LanguageSelect;



// WEBPACK FOOTER //
// /app/apps/ms/src/components/LanguageSelect.js